import { render, staticRenderFns } from "./ContributionsEdit.vue?vue&type=template&id=0d768784&scoped=true"
import script from "./ContributionsEdit.vue?vue&type=script&lang=ts"
export * from "./ContributionsEdit.vue?vue&type=script&lang=ts"
import style0 from "./ContributionsEdit.vue?vue&type=style&index=0&id=0d768784&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d768784",
  null
  
)

export default component.exports